import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Questions = () => {
  return (
    <>
      {/* Primer acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿En qué consiste el servicio de Ayuda Tecnológica Online?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            El servicio permite resolver, en tiempo real, las dudas o incidencias relacionadas con el uso habitual de equipos informáticos; la asistencia se presta a través de una ventana de diálogo tipo chat, que permitirá al usuario contactar con nuestros técnicos expertos. Adicionalmente, en caso de que el usuario no pueda conectar su equipo a Internet, podrá solicitar asistencia por teléfono, siendo el chat la opción recomendada.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Segundo acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿Cuál es el alcance del servicio?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            El servicio de Asistencia tecnológica incluye, entre otras, las siguientes prestaciones:
            <ul>
              <li>Resolución de incidencias técnicas de los dispositivos del usuario provocadas por mal funcionamiento de cualquiera de las aplicaciones o sistemas soportados por el servicio.</li>
              <li>Ayuda en la instalación y uso de aplicaciones y del equipo, proporcionando una ayuda interactiva, directa y resolutiva.</li>
              <li>Configuración del sistema y de las aplicaciones del equipo, con el objeto de optimizar el funcionamiento, añadir o eliminar funcionalidades, dispositivos y aplicaciones.</li>
              <li>Instalación y configuración de periféricos de entrada y salida de los principales fabricantes del mercado.</li>
              <li>En el caso particular de los dispositivos móviles, los técnicos gestionarán todas las consultas relacionadas con las siguientes tareas, entre otras:
                <ul>
                  <li>Copia de seguridad y restauración del contenido de los dispositivos; los datos se almacenarán en el ordenador propiedad del cliente.</li>
                  <li>Descarga de contenidos y aplicaciones.</li>
                  <li>Instalación y desinstalación de cualquier tipo de aplicación o software que el usuario haya adquirido (software legal).</li>
                  <li>Actualizaciones de software y reseteo al estado de fábrica (si el modelo y firmware del dispositivo lo permite).</li>
                  <li>Actualización de navegadores GPS y mapas (si los medios están disponibles en la web del fabricante).</li>
                </ul>
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Tercer acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿En qué consiste el servicio para periféricos?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            Para poder solucionar las consultas relacionadas con periféricos y dispositivos móviles se solicitará al usuario que conecte el dispositivo a su ordenador mediante cable. Igualmente, deberá disponer del software de gestión del fabricante del dispositivo compatible con el sistema operativo instalado en el equipo.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default Questions;
